import React from "react";
import styled, { css } from "styled-components";

import { IProduct } from "src/core/products/api/products.api";
import useDrop from "src/core/drops/hooks/useDrop";
import useGlobalSettings from "src/core/shared/hooks/useGlobalSettings";
import { ProductQuantityButton } from "src/core/products/components/ProductDetails";

import { PartNumber } from "../../PartNumber";
import {
  ProductLabel,
  ProductPricing
} from "../ProductDetails";
import { ProductQuantityRef } from "../ProductQuantity";

interface RapidOrderEntryCardProps {
  product: IProduct;
  onBlur?: () => void;
  onFocus?: () => void;
  className?: string;
  productQuantityRef?: React.Ref<ProductQuantityRef>;
}
export const RapidOrderEntryCard: React.ReactFCWithChildren<RapidOrderEntryCardProps> = ({
  product, onBlur, onFocus, className, productQuantityRef
}) => {
  const [ { drop } ] = useDrop();
  const [ { globalSettings } ] = useGlobalSettings();
  const installedModules = globalSettings?.installedModules || [];

  return (
    <StyledOrderCardWrapper className={`${className ? className : ""}`}>
      <div>
        <ProductLabel
          product={product}
          view="compact"
          hidePackSize
        />

        <div className="price-and-pack">
          <PartNumber product={product} />

          <ProductPricing
            product={product}
            drop={drop}
            installedModules={installedModules}
          />
        </div>
      </div>

      <div className="quantity-wrapper">
        <ProductQuantityButton
          productQuantityRef={productQuantityRef}
          product={product}
          layout="rapid"
          onBlur={() => {
            onBlur && onBlur();
          }}
          onFocus={onFocus}
        />
      </div>

    </StyledOrderCardWrapper>
  );
};

const StyledOrderCardWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    padding: ${theme.spacing.padding.md};
    border: 1px solid ${theme.colors.lightGrey};
    border-radius: ${theme.borderRadius};
    width: 195px;
    min-width: 195px;
    margin-right: ${theme.spacing.margins.md};
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .quantity-wrapper {
      margin-top: ${theme.spacing.margins.md};
      display: flex;
      justify-content: center;      
    }

    &.active {
      border-color: ${theme.colors.primaryDark};
      .layout-rapid {
        input {
          border-color: ${theme.colors.primaryDark};
          border-left: 1px solid ${theme.colors.primaryDark};
        }
      }
    }

    .price-and-pack {
      display: flex;
      justify-content: space-between;
      align-items: center;

      > div {
        span {
          font-size: ${theme.fonts.sizes.sub};
        }

        &.part-number-wrapper {
          flex-direction: column;
        }

        .packsize-wrapper:before {
          display: none;
        }
      }
    }

    .product-label {
      margin-bottom: ${theme.spacing.margins.xs};
    }

  `}
`;
